export default __webpack_public_path__ + "static/media/est-sp.b317505f.webp";